import * as Types from '../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type WholeSyncablePriceListTariffFragment = { readonly __typename?: 'SyncablePriceListTariff', readonly id: string, readonly name: string, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly createdByUserId: string, readonly updatedAt: string, readonly updatedByUserId: string, readonly deleted: boolean } };

export type SyncPriceListTariffPullQueryVariables = Types.Exact<{
  input: Types.PullPriceListTariffInput;
}>;


export type SyncPriceListTariffPullQuery = { readonly __typename?: 'Query', readonly pullPriceListTariff: { readonly __typename?: 'PullPriceListTariffResult', readonly checkpoint?: { readonly __typename?: 'SyncableCheckpoint', readonly id: string, readonly updatedAt: string } | null, readonly documents: ReadonlyArray<{ readonly __typename?: 'SyncablePriceListTariff', readonly id: string, readonly name: string, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly createdByUserId: string, readonly updatedAt: string, readonly updatedByUserId: string, readonly deleted: boolean } }> } };

export const WholeSyncablePriceListTariffFragmentDoc = gql`
    fragment WholeSyncablePriceListTariff on SyncablePriceListTariff {
  id
  name
  meta {
    createdAt
    createdByUserId
    updatedAt
    updatedByUserId
    deleted
  }
}
    `;
export const SyncPriceListTariffPullDocument = gql`
    query SyncPriceListTariffPull($input: PullPriceListTariffInput!) {
  pullPriceListTariff(input: $input) {
    checkpoint {
      id
      updatedAt
    }
    documents {
      ...WholeSyncablePriceListTariff
    }
  }
}
    ${WholeSyncablePriceListTariffFragmentDoc}`;

/**
 * __useSyncPriceListTariffPullQuery__
 *
 * To run a query within a React component, call `useSyncPriceListTariffPullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSyncPriceListTariffPullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSyncPriceListTariffPullQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncPriceListTariffPullQuery(baseOptions: Apollo.QueryHookOptions<SyncPriceListTariffPullQuery, SyncPriceListTariffPullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SyncPriceListTariffPullQuery, SyncPriceListTariffPullQueryVariables>(SyncPriceListTariffPullDocument, options);
      }
export function useSyncPriceListTariffPullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SyncPriceListTariffPullQuery, SyncPriceListTariffPullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SyncPriceListTariffPullQuery, SyncPriceListTariffPullQueryVariables>(SyncPriceListTariffPullDocument, options);
        }
export type SyncPriceListTariffPullQueryHookResult = ReturnType<typeof useSyncPriceListTariffPullQuery>;
export type SyncPriceListTariffPullLazyQueryHookResult = ReturnType<typeof useSyncPriceListTariffPullLazyQuery>;
export type SyncPriceListTariffPullQueryResult = Apollo.QueryResult<SyncPriceListTariffPullQuery, SyncPriceListTariffPullQueryVariables>;